import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ViaCepService {
  constructor(private http: HttpClient) {}

  public GetBuscarCep(cep: string, { onSuccess, onError }: any) {
    if (cep.length === 8) {
      this.http.get(`https://viacep.com.br/ws/${cep}/json/`).subscribe({
        next: (response: any) => {
          if (response.erro) {
            onError('CEP inválido!');
          } else {
            onSuccess(response);
          }
        },
        error: onError,
      });
    }
  }
}
